/**
 * @see @antv/g2
 */
import _ from 'lodash'

const RGB_REG = /rgba?\(([\s.,0-9]+)\)/ // 创建辅助 tag 取颜色

function createTmp(): HTMLElement {
  const i = document.createElement('i')
  i.title = 'Web Colour Picker'
  i.style.display = 'none'
  document.body.appendChild(i)
  return i
} // 获取颜色之间的插值

function getValue(start: number[], end: number[], percent: number, index: number) {
  const value = start[index] + (end[index] - start[index]) * percent
  return value
} // 数组转换成颜色

function arr2rgb(arr: number[]): string {
  return '#' + toHex(arr[0]) + toHex(arr[1]) + toHex(arr[2])
} // 将数值从 0-255 转换成16进制字符串

function toHex(value: number): string {
  value = Math.round(value)
  let result = value.toString(16)

  if (result.length === 1) {
    result = '0' + result
  }

  return result
}

function calColor(colors: number[][], percent: number) {
  if (isNaN(percent) || !_.isNumber(percent) || percent < 0) {
    percent = 0
  }

  if (percent > 1) {
    percent = 1
  }

  const steps = colors.length - 1
  const step = Math.floor(steps * percent)
  const left = steps * percent - step
  const start = colors[step]
  const end = step === steps ? start : colors[step + 1]
  const rgb = arr2rgb([
    getValue(start, end, left, 0),
    getValue(start, end, left, 1),
    getValue(start, end, left, 2),
  ])
  return rgb
} // rgb 颜色转换成数组

export function rgb2arr(str: string): number[] {
  const arr = []
  arr.push(parseInt(str.substr(1, 2), 16))
  arr.push(parseInt(str.substr(3, 2), 16))
  arr.push(parseInt(str.substr(5, 2), 16))
  return arr
}

const colorCache: { [key: string]: string } = {}
let iEl: HTMLElement | null = null

/**
 * 将颜色转换到 rgb 的格式
 * @param  {String} color 颜色
 * @return {String} 将颜色转换到 '#ffffff' 的格式
 */
export function toRGB(color: string): string {
  // 如果已经是 rgb的格式
  if (color[0] === '#' && color.length === 7) {
    return color
  }

  if (!iEl) {
    // 防止防止在页头报错
    iEl = createTmp()
  }

  let rst: string

  if (colorCache[color]) {
    rst = colorCache[color]
  } else {
    iEl.style.color = color
    const { defaultView } = document
    if (!defaultView) {
      // tslint:disable-next-line:no-console
      console.error('document.defaultView undefined')
      return ''
    }
    const tmpColor = defaultView.getComputedStyle(iEl, '').getPropertyValue('color')
    const matchs = RGB_REG.exec(tmpColor)
    if (!matchs) {
      throw Error(` ${tmpColor} not match ${RGB_REG}`)
    }
    const cArray = matchs[1].split(/\s*,\s*/)
    rst = arr2rgb(cArray.map(Number))
    colorCache[color] = rst
  }

  return rst
}

/**
 * 获取渐变函数
 * @param  {Array} colors 多个颜色
 * @return {String} 颜色值
 */
export function gradient(colors: string | string[]) {
  const points: number[][] = []

  if (_.isString(colors)) {
    colors = colors.split('-')
  }

  _.each(colors, (color: string) => {
    if (color.indexOf('#') === -1) {
      color = toRGB(color)
    }

    points.push(rgb2arr(color))
  })
  return (percent: number) => {
    return calColor(points, percent)
  }
}
